<template>
  <v-container fluid>
    <v-layout
      row
      wrap
      flat
      style="z-index: 3"
      class="white border justify-center align-center py-2 px-3"
    >
      <h3 class="px-2">{{ $t("non_lctr_report") }}</h3>
      <v-autocomplete
        outline
        clearable
        singleLine
        hideDetails
        autocomplete
        class="mx-2"
        item-value="id"
        item-text="name"
        @change="initData"
        v-model="branch_id"
        :disabled="loading"
        :items="branch_filters"
        style="max-width: 370px"
        :placeholder="$t('branch')"
        v-if="userCan('view_all_branches_report')"
      />
      <v-spacer class="hidden-sm-and-down" />
      <!-- v-if="customer_id" -->
      <v-date
        singleLine
        solo-inverted
        :hideDetails="true"
        :clearable="false"
        @input="initData"
        format="YYYY-MM-DD"
        v-model="start_date"
        :disabled="loading"
        value-type="YYYY-MM-DD"
        :placeholder="$t('date')"
        input_id="start_date_lctr"
        class="mx-2 flex xs12 md2 hide-details"
      />
      <!-- <h1>HEEL</h1> -->
      <v-date
        singleLine
        :hideDetails="true"
        :clearable="false"
        @input="initData"
        v-model="end_date"
        :disabled="loading"
        format="YYYY-MM-DD"
        input_id="end_date_lctr"
        value-type="YYYY-MM-DD"
        :placeholder="$t('date')"
        class="mx-2 flex xs12 md2 hide-details"
      />
      <!-- style="max-width:250px;" -->

      <!-- <v-flex xs12 class="di-flex justify-center align-end">
      <v-text-field
          outline
          hide-details
          class="rounded"
          v-model="search"
          prepend-inner-icon="search"
          :placeholder="$t('bill_number')"
        />

      </v-flex>-->
    </v-layout>
    <v-layout
      row
      wrap
      flat
      style="z-index: 3"
      class="white border justify-start align-center py-2 px-3"
    >
      <!-- <h3 class="px-3">MIN-MAX</h3>
      <v-text-field
        outline
        single-line
        hide-details
        data-vv-name="max"
        style="max-width: 250px"
        v-model="minimum_amount"
        :title="$t('minimum_amount')"
        v-currency="{ currency: null }"
        class="flex xs4 sm3 has_currency"
        :placeholder="$t('minimum_amount')"
      >
        <v-menu offset-y slot="append">
          <a
            slot="activator"
            class="mx-2 mt-2 font-weight-medium subheading align-center"
          >
            <span>{{ smbl(selected_currency_id) }}</span>
          </a>
          <v-list>
            <v-list-tile
              :key="index + 'se'"
              v-for="(item, index) in currencies"
              @click="selected_currency_id = item.id"
            >
              <v-list-tile-title>{{ item.name }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-text-field>
      <v-text-field
        outline
        clearable
        single-line
        hide-details
        data-vv-name="max"
        style="max-width: 250px"
        v-model="maximum_amount"
        :title="$t('maximum_amount')"
        v-currency="{ currency: null }"
        class="flex xs4 sm3 has_currency"
        :placeholder="$t('maximum_amount')"
      />-->
      <async-autocomplete
        outline
        autofocus
        clearable
        single-line
        hide-details
        item-value="id"
        url="/transfers/create"
        queries="external=true"
        @setItem="initData"
        v-model="customer_id"
        item-text="full_name"
        style="max-width: 43 0px"
        :placeholder="$t('customer')"
        :appendItem="selectedCustomer"
        class="flex xs12 md4 right-hint"
      >
        <template v-slot:item="{item}">
          <v-list-tile-avatar>
            <img :src="item.image" />
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title >{{ item.full_name }}</v-list-tile-title>
            <v-list-tile-sub-title>{{ $t(item.type) }}</v-list-tile-sub-title>
          </v-list-tile-content>
        </template>
      </async-autocomplete>
      <v-spacer />
      <v-btn
        icon
        flat
        medium
        @click="initData"
        :loading="loading"
        :title="$t('refresh')"
        color="grey darken-2"
      >
        <v-icon>refresh</v-icon>
      </v-btn>
      <v-btn icon flat @click="printTable" :title="$t('print')" color="grey darken-2">
        <v-icon>print</v-icon>
      </v-btn>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <exchanges
          class="mt-3"
          @saved="initData"
          @customer_changed="customerChanged"
          v-bind="{
            lctr: true,
            initList: false,
            en_date: end_date,
            st_date: start_date,
            dashboardView: true,
            exchanges: co_exchanges,
          }"
        />
        <send-transfers
          type="send"
          class="mt-3"
          @saved="initData"
          label="send_transfers"
          @customer_changed="customerChanged"
          v-bind="{
            lctr: true,
            initList: false,
            en_date: end_date,
            st_date: start_date,
            dashboardView: true,
            transfers: send_transfers,
          }"
        />
        <receive-transfers
          class="mt-3"
          type="receive"
          @saved="initData"
          label="received_transfers"
          @customer_changed="customerChanged"
          v-bind="{
            lctr: true,
            initList: false,
            en_date: end_date,
            st_date: start_date,
            dashboardView: true,
            transfers: received_transfers,
          }"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import curjs from "currency.js";
import exchanges from "@/views/roznamcha/tabs/exchanges";
import { exchange, customersMixin } from "@/mixins/index.js";
import sendTransfers from "@/views/roznamcha/tabs/sendTransfers";
import receiveTransfers from "@/views/roznamcha/tabs/receiveTransfers";
let currentDate = new Date();
currentDate.setDate(currentDate.getDate() - 1);
export default {
  name: "nonLCTR",
  mixins: [customersMixin, exchange],

  components: {
    exchanges,
    sendTransfers,
    receiveTransfers
  },

  data: () => ({
    search: null,
    exchanges: [],
    transfers: [],
    currencies: [],
    branch_id: "",
    customer_id: "",
    loading: false,
    branch_filters: [],
    selected_currency_id: 2, //afn
    maximum_amount: "",
    minimum_amount: 500000,
    end_date: new Date().toLocaleDateString("en-ca"),
    start_date: new Date().toLocaleDateString("en-ca"),
    selectedCustomer: false
  }),
  computed: {
    customers: vm => vm.initialData.customers,

    selectedBranch: vm =>
      vm.branch_filters.find(x => x.id == vm.branch_id) || {},
    baseCurrency: vm => {
      let usd = 1;
      // currencies has rank also, works as currency
      return vm.currencies[usd] || { rank: 1, name: "" };
    },

    maximumLctrAmount() {
      if (!Number(this.maximum_amount)) return Number.POSITIVE_INFINITY;
      let fromCurrency = this.currencies[this.selected_currency_id] || {
        rank: 1,
        name: "",
        rate: 1
      };
      return Number(
        this.exchange(
          fromCurrency,
          this.baseCurrency,
          curjs(this.maximum_amount).value,
          fromCurrency.rate
        )
      );
    },

    minimumLctrAmount() {
      let fromCurrency = this.currencies[this.selected_currency_id] || {
        rank: 1,
        name: "",
        rate: 1
      };
      return Number(
        this.exchange(
          fromCurrency,
          this.baseCurrency,
          curjs(this.minimum_amount).value,
          fromCurrency.rate
        )
      );
    },
    lctrAmount() {
      let afn_currency_id = 2;
      let fromCurrency = this.currencies[afn_currency_id] || {
        rank: 1,
        name: "",
        rate: 1
      };
      return Number(
        this.exchange(
          fromCurrency,
          this.baseCurrency,
          500000,
          fromCurrency.rate
        )
      );
    },

    co_exchanges() {
      return this.exchanges.filter(item => this.isExchangeLCTR(item));
    },
    send_transfers() {
      return this.transfers.filter(
        item => item.type == "send" && this.isTrnasferLCTR(item, "send")
      );
    },
    received_transfers() {
      let items = this.transfers.filter(
        item => item.type == "receive" && this.isTrnasferLCTR(item, "receive")
      );
      return items;
    }
  },
  methods: {
    customerChanged(id, item) {
      this.selectedCustomer = item;
      this.customer_id = id;
      this.initData();
    },
    isTrnasferLCTR(item, type) {
      if (this.customer_id) return true;
      let items = this.transfers.filter(
        x =>
          (x.customer_id == item.customer_id ||
            x.receiver_customer_id == item.customer_id) &&
          x.type == type
          && this.areDatesWithinTwoDays(x.date, item.date)
      );

      let total = curjs(0);
      items.forEach(x => {
        total = total.add(this.exchangeToBase(x.amount, x.currency_id));
      });
      return (
        total.value < this.minimumLctrAmount  
      );
    },

    areDatesWithinTwoDays(date1, date2) {
      date1 = new Date(date1)
      date2 = new Date(date2)
        // Get the time difference in milliseconds
      let timeDifference = Math.abs(date1.getTime() - date2.getTime());

      // Calculate the number of milliseconds in two days
      let twoDaysInMillis = 2 * 24 * 60 * 60 * 1000;

      // Check if the time difference is less than or equal to two days
      return timeDifference <= twoDaysInMillis;
    },

    isExchangeLCTR(item) {
      if (this.customer_id) return true;
      // let items = this.exchanges.filter((x) =>
      //   x.details
      //     ? x.details.reg_id == item.details.reg_id
      //     : x.customer_id == item.customer_id
      // );
      let items = this.exchanges.filter(x => x.customer_id == item.customer_id && this.areDatesWithinTwoDays(x.date, item.date));
      let total = curjs(0);
      items.forEach(x => {
        total = total.add(this.exchangeToBase(x.amount, x.sale_currency_id));
      });
      return (
        total.value < this.minimumLctrAmount  
      );
    },

    exchangeToBase(amount, currency_id) {
      let fromCurrency = this.currencies[currency_id] || {
        rank: 1,
        name: "",
        rate: 1
      };

      return this.exchange(
        fromCurrency,
        this.baseCurrency,
        amount,
        fromCurrency.rate
      );
    },

    getFilteredItem(items, key) {
      if (this.search) {
        return items.filter(item => {
          return ("" + item[key])
            .toLowerCase()
            .includes(this.search.toLowerCase());
        });
      }
      return items;
    },

    getBranches() {
      this.axios.get("branches").then(res => {
        let items = res.data;
        items.push({
          id: 0,
          name: this.$t("all_branches")
        });
        this.branch_filters = items;
      });
    },

    initData() {
      this.loading = true;

      //reset start_date back to 48 hours before
      // if (!this.customer_id) {
      //   let curDate = new Date(this.end_date);
      //   curDate.setDate(curDate.getDate() - 1);
      //   this.start_date = curDate.toLocaleDateString("en-ca");
      // }
      let route = `reports?lctr=true&start_date=${this.start_date}&end_date=${this.end_date}`;
      if (this.customer_id) route += `&customer_id=${this.customer_id}`;
      if (this.branch_id > 0) route += `&branch_id=${this.branch_id}`;
      this.axios
        .get(route)
        .then(resp => {
          this.currencies = resp.data.mapped_rates;
          this.transfers = resp.data.transfers;
          this.exchanges = resp.data.exchanges;
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rateUpdated() {
      this.initData();
    },

    printTable() {
      const { co_exchanges, send_transfers, received_transfers } = this;
      let title = this.customer_id
        ? `${this.$t("transactions_report")} ${this.$t("from")} (${
            this.start_date
          } ${this.persianDateFilter(this.start_date, true)}) ${this.$t(
            "to"
          )} (${this.end_date} ${this.persianDateFilter(this.end_date, true)})`
        : `${this.$t("non_lctr_report")} (${this.end_date} ${this.persianDateFilter(
            this.end_date,
            true
          )})`;

      let branch_name = this.customer_id
        ? `${this.selectedCustomer.full_name}`
        : this.selectedBranch.name;
      let data = {
        headers: [
          { text: this.$t("customer"), value: "name" },
          { text: this.$t("phones"), value: "pretty_phone" },
          { text: this.$t("description"), value: "address" }
        ],
        items: {
          co_exchanges,
          send_transfers,
          received_transfers
        },
        title,
        lctr: true,
        branch_name,
        landscape: true
      };

      this.$store.commit("ReportsModule/setDailyReport", data);
      this.$router.push("/print/daily-transactions");
    }
  },
  created() {
    this.branch_id = this.userBranch.id;
    this.initData();
    this.getBranches();
  }
};
</script>